export default __webpack_public_path__ + "static/media/1_0046.4e9c5f92.webp";